import { extend } from '@thd-nucleus/data-sources';

import { PromoListDataModel } from './PromoListDataModel';

export const PromoList2DrawerDataModel = extend(
  PromoListDataModel,
);
